/**
 * Action types for POE Settings functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_POE_SETTINGS = 'GET_POE_SETTINGS';
export const GET_POE_SETTINGS_SUCCESS = 'GET_POE_SETTINGS_SUCCESS';
export const GET_POE_SETTINGS_FAIL = 'GET_POE_SETTINGS_FAIL';
export const EDIT_POE_SETTINGS = 'EDIT_POE_SETTINGS';
export const EDIT_POE_SETTINGS_SUCCESS =  'EDIT_POE_SETTINGS_SUCCESS';
export const EDIT_POE_SETTINGS_FAIL =  'EDIT_POE_SETTINGS_FAIL';
export const CONTINOUS_POE_POWER = 'CONTINOUS_POE_POWER';
export const CONTINOUS_POE_POWER_SUCCESS = 'CONTINOUS_POE_POWER_SUCCESS';
export const CONTINOUS_POE_POWER_FAIL = 'CONTINOUS_POE_POWER_FAIL';